/**
 * SEO 配置 - chat (Italiano)
 */

export default {
    chat: {
        title: 'Chat IA - Assistente Multi-Modello | WeryAI',
        description:
            'Chatta con i migliori modelli di IA su WeryAI. Confronta le risposte affiancate in più finestre. Genera immagini, video e musica da un unico spazio di lavoro.',
        keywords:
            'chat IA, assistente IA, chat multi-modello, chatbot IA, confrontare modelli IA, chat IA affiancato, alternativa GPT, spazio di lavoro IA, WeryAI',
        og_title: 'Chat IA - Assistente Multi-Modello | WeryAI',
        og_description:
            'Chatta con i migliori modelli di IA e confronta le risposte affiancate. Genera immagini, video e altro. Prova gratis su WeryAI.',
        twitter_title: 'Chat IA - Assistente Multi-Modello | WeryAI',
        twitter_description:
            'Chatta con i migliori modelli di IA e confronta le risposte affiancate. Genera immagini, video e altro. Prova gratis su WeryAI.',
    },
}
